import React from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'react-date-picker';
import styledComponent from '../../../utils/styledComponent';
import theme from '../../../theme';

const StyledDiv = styledComponent('div', {
  '& .react-date-picker__wrapper': {
    border: theme.borders.input,
    borderRadius: theme.radii.input,
    padding: theme.spacing.inputPadding,
    minHeight: theme.sizes.selectMinHeight,
    background: theme.colors.bgCard,
    transition: theme.transitions.default,
  },
  '& .react-date-picker__wrapper:hover': {
    borderColor: theme.colors.focusRing,
  },
  '& .react-date-picker__wrapper:focus-within': {
    borderColor: theme.colors.focusRing,
    boxShadow: `0 0 0 2px ${theme.colors.focusRing}33`,
  },
  '& .react-date-picker__inputGroup__input': {
    ...theme.typography.body,
    color: theme.colors.textBody,
  },
  '& .react-date-picker__button': {
    padding: theme.spacing.iconPadding,
  },
  '& .react-date-picker__button svg': {
    width: theme.sizes.icon,
    height: theme.sizes.icon,
    stroke: theme.colors.textHint,
  },
  '& .react-date-picker__button:enabled:hover svg, & .react-date-picker__button:enabled:focus svg':
    {
      stroke: theme.colors.focusRing,
    },
});

function DateField({ value, onChange, minDate, disabled, format }) {
  return (
    <StyledDiv>
      <DatePicker
        value={value}
        onChange={onChange}
        minDate={minDate}
        disabled={disabled}
        format={format}
      />
    </StyledDiv>
  );
}

DateField.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.instanceOf(Date),
    PropTypes.oneOf([null]),
  ]),
  onChange: PropTypes.func.isRequired,
  minDate: PropTypes.oneOfType([
    PropTypes.instanceOf(Date),
    PropTypes.oneOf([null]),
  ]),
  disabled: PropTypes.bool,
  format: PropTypes.string,
};

DateField.defaultProps = {
  value: null,
  minDate: undefined,
  disabled: false,
  format: 'MM/dd/y',
};

export default DateField;
